var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"organization-risk-decision-view"},[_c('risk-rating-definition'),_c('hr'),_c('organization-risk-target-definition')],1)}
var staticRenderFns = []

export { render, staticRenderFns }